module.exports = __webpack_public_path__ + "static/media/sok-project-map.458fe44f.png";